import { render, staticRenderFns } from "./ProjectChangeEmailList.vue?vue&type=template&id=1bdb8ace&"
import script from "./ProjectChangeEmailList.vue?vue&type=script&lang=js&"
export * from "./ProjectChangeEmailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports